import { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Lock, Mail } from 'lucide-react';

export default function DashboardLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err) { setError(err.message); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#f5f6f7] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/ees-logo.png" alt="EES" className="h-12 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-[#32373c]">EES Dashboard</h1>
          <p className="text-sm text-gray-500 mt-1">Interner Bereich</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-4" data-testid="login-form">
          {error && <div className="text-sm text-red-600 bg-red-50 rounded p-3 border border-red-200" data-testid="login-error">{error}</div>}
          <div>
            <Label className="text-gray-600 text-sm">E-Mail</Label>
            <div className="relative mt-1">
              <Mail className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
              <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="name@ees-energiespeicher.de" className="pl-9 bg-white border-gray-300" data-testid="login-email" required />
            </div>
          </div>
          <div>
            <Label className="text-gray-600 text-sm">Passwort</Label>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" />
              <Input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Passwort" className="pl-9 bg-white border-gray-300" data-testid="login-password" required />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#9ec043] hover:bg-[#8aad38] text-white" data-testid="login-submit">
            {loading ? 'Anmelden...' : 'Anmelden'}
          </Button>
        </form>
      </div>
    </div>
  );
}
